import { ListData } from '../hooks/useListData';

export const demoListData: ListData = {
  categories: [
    {
      id: 'catagory-a',
      name: 'travel documents',
      items: [
        {
          id: 'item-a01',
          checked: false,
          name: 'passport',
        },
        {
          id: 'item-a02',
          checked: false,
          name: 'travel insurance',
        },
        {
          id: 'item-a03',
          checked: false,
          name: 'local currency',
        },
        {
          id: 'item-a04',
          checked: false,
          name: 'credit cards',
        },
      ],
      color: '#f0d6f7',
    },
    {
      id: 'catagory-b',
      name: 'covid must-haves',
      items: [
        {
          id: 'item-b01',
          checked: false,
          name: 'face mask',
        },
        {
          id: 'item-b02',
          checked: false,
          name: 'hand sanitizer',
        },
      ],
      color: '#fdcc69',
    },
    {
      id: 'catagory-c',
      name: 'electronics',
      items: [
        {
          id: 'item-c01',
          checked: false,
          name: 'laptop & charger',
        },
        {
          id: 'item-c02',
          checked: false,
          name: 'phone & charger',
        },
        {
          id: 'item-c03',
          checked: false,
          name: 'headphones',
        },
      ],
      color: '#ffeead',
    },
    {
      id: 'catagory-d',
      name: 'medication',
      items: [
        {
          id: 'item-d01',
          checked: false,
          name: 'prescriptions',
        },
        {
          id: 'item-d02',
          checked: false,
          name: 'pain relief',
        },
      ],
      color: '#d6eff7',
    },
    {
      id: 'catagory-e',
      name: 'clothes',
      items: [
        {
          id: 'item-e01',
          checked: false,
          name: 't-shirts',
        },
        {
          id: 'item-e02',
          checked: false,
          name: 'shorts',
        },
        {
          id: 'item-e03',
          checked: false,
          name: 'pajamas',
        },
        {
          id: 'item-e04',
          checked: false,
          name: 'underwear',
        },
      ],
      color: '#fbdadaf5',
    },
    {
      id: 'catagory-f',
      name: 'toiletries',
      items: [
        {
          id: 'item-f01',
          checked: false,
          name: 'shampoo',
        },
        {
          id: 'item-f02',
          checked: false,
          name: 'body wash',
        },
        {
          id: 'item-f03',
          checked: false,
          name: 'toothbrush/toothpaste',
        },
      ],
      color: '#b0ebb2',
    },
  ],
};
